import React from 'react';
import './Reviews.css';

const reviews = [
  {
    text:
      "Super accueil et bubble tea délicieux. Le lieu est cosy et très instagrammable, je reviendrai avec des amis !",
    author: 'Avis public en ligne',
    source: 'Internet',
    rating: 5,
  },
  {
    text:
      "Excellents smoothies et mini pancakes. Service rapide et souriant, parfait pour une pause sucrée en soirée.",
    author: 'Avis public en ligne',
    source: 'Internet',
    rating: 5,
  },
  {
    text:
      "Ambiance rose super mignonne, musique sympa et boissons au top. Bon rapport qualité/prix dans le 11e.",
    author: 'Avis public en ligne',
    source: 'Internet',
    rating: 4,
  },
];

const Stars = ({ value }) => {
  const full = '★'.repeat(value);
  const empty = '☆'.repeat(5 - value);
  return <span className="review-stars" aria-label={`${value} sur 5`}>{full}{empty}</span>;
};

const Reviews = () => {
  return (
    <section className="reviews-section" id="reviews">
      <div className="container">
        <div className="reviews-header">
          <h2 className="reviews-title">Ils parlent de nous</h2>
          <p className="reviews-subtitle">De vrais retours qui reflètent l’expérience Pinky Cloud</p>
        </div>
        <div className="reviews-grid">
          {reviews.map((r, idx) => (
            <blockquote key={idx} className="review-card">
              <div className="review-top">
                <Stars value={r.rating} />
                <span className="review-badge">Vérifié</span>
              </div>
              <p className="review-text">“{r.text}”</p>
              <footer className="review-footer">
                <span className="review-author">{r.author}</span>
                <span className="review-sep">·</span>
                <span className="review-source">{r.source}</span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;

